module.exports = __webpack_public_path__ + "static/media/pulverizador2.b741d32c.svg";